/**
 * Extracts CSS content from HTML string
 * @param htmlString - HTML string that may contain <style> tags
 * @returns Extracted CSS content
 */
export const extractCssFromHtml = (htmlString: string): string => {
  if (!htmlString) {
    return ''
  }

  // Create a temporary DOM element to parse the HTML
  const tempDiv: HTMLDivElement = document.createElement('div')
  tempDiv.innerHTML = htmlString

  // Find all style tags
  const styleTags: NodeListOf<HTMLStyleElement> =
    tempDiv.querySelectorAll('style')

  // Extract CSS content from style tags
  let cssContent: string = ''
  styleTags.forEach((styleTag: HTMLStyleElement) => {
    cssContent += styleTag.textContent || ''
  })

  return cssContent
}

export default extractCssFromHtml
